export enum FilterType {
  Initial = 'initial',
  Approval = 'approval',
  Accounting = 'accounting',
  Payment = 'payment',
  NotValidated = 'notValidated'
}
